var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStsHimart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 0.00162652C14.6353 -0.00484713 7.07252 7.57064 7.05861 16.9438C7.05218 21.1936 8.78712 24.824 11.4021 27.9198C16.1709 33.5656 20.3433 39.5106 22.6213 46.646C22.8271 47.2902 23.1334 48.0218 24.0136 47.9995C24.9713 47.9752 25.2287 47.1553 25.456 46.4613C27.5938 39.9324 31.1653 34.2917 35.6786 29.1694C38.3614 26.1244 40.5128 22.6158 40.8738 18.4946C41.7539 8.45106 33.8648 -0.135773 23.9974 0.00162652Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6475 12.7061H20.471V16.2355H23.2945V12.7061H26.118V16.2355V19.059V22.5884L23.2945 23.2943V19.059L20.471 19.059V22.5884L17.6475 23.2943V19.059V16.2355V12.7061Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5303 12.7061H30.3538V15.5296H27.5303V12.7061Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5303 16.9414H30.3538V22.5885L27.5303 23.2943V16.9414Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsHimart);
export default __webpack_public_path__ + "static/media/stsHimart.cf15f6f1925e29a4422a0d1b25adbdde.svg";
export { ForwardRef as ReactComponent };